import styled, { css } from 'styled-components';
import { Icon } from '../components/Icon/Icon';
import { black32, black48, black8, purple, purple32, purple72, purpleAlpha56, red, red8, redAlpha56, white } from './colors';
import { getFocusRing } from './mixins';
import { rem } from './rem';
import { body2, formLabel } from './typography';
import { unit } from './unit';
export const ToggleWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ToggleWrapper",
  componentId: "sc-82shdz-0"
})(["display:flex;align-items:flex-start;"]);
export const ToggleElement = /*#__PURE__*/styled.div.withConfig({
  displayName: "ToggleElement",
  componentId: "sc-82shdz-1"
})(["display:inline-block;vertical-align:middle;position:relative;width:", ";height:", ";flex-shrink:0;"], rem(16), rem(16));
export const Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-82shdz-2"
})(["margin:0;width:100%;height:100%;border:0;-webkit-appearance:none;opacity:0;"]);
export const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-82shdz-3"
})(["display:none;"]);
export const overlayStyles = /*#__PURE__*/css(["display:flex;align-items:center;justify-content:center;position:absolute;pointer-events:none;top:0;right:0;bottom:0;left:0;background-color:", ";border:1px solid ", ";color:", ";box-shadow:", ";", ".focus-visible + &,", ":hover + &,", ":checked + &{border-color:", ";}", ".focus-visible + &{box-shadow:", ";}", ":active + &{background-color:", ";border-color:", ";box-shadow:none;}", ":checked:hover + &{border-color:", ";background-color:", ";}", ":checked:active + &{border-color:", ";background-color:", ";}", ":checked + &{background-color:", ";}", ":checked + & > ", "{display:inline-flex;}", "[aria-invalid] + &{background-color:", ";border-color:", ";color:", ";}", ".focus-visible[aria-invalid] + &{box-shadow:", ";}", ":disabled + &{background-color:", ";border-color:", ";color:", ";box-shadow:none;}"], white, black32, white, ({
  highlighted
}) => highlighted && ` ${getFocusRing(purpleAlpha56)}`, Input, Input, Input, purple, Input, getFocusRing(purpleAlpha56), Input, purple, purple, Input, purple72, purple72, Input, purple32, purple32, Input, purple, Input, StyledIcon, Input, red8, red, red, Input, getFocusRing(redAlpha56), Input, black8, black32, black32);
export const Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-82shdz-4"
})(["", ";display:block;", ""], formLabel, props => props.disabled ? {
  color: black32
} : null);
export const LabelDescription = /*#__PURE__*/styled.span.withConfig({
  displayName: "LabelDescription",
  componentId: "sc-82shdz-5"
})(["", " color:", ""], body2, props => props.disabled ? black32 : black48);
export const LabelWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-82shdz-6"
})(["margin-left:", ";"], unit(2));